import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { archivePromotion, createPromotion, fetchPromotions } from '@/api/promote';
import type { PromotionCreatePayload } from '@/types/promote';

export function usePromotions(filters?: { isActive?: boolean; kind?: string }) {
  return useQuery({
    queryKey: ['crm', 'promotions', filters?.isActive ?? 'all', filters?.kind ?? 'all'],
    queryFn: () => fetchPromotions(filters),
  });
}

export function useCreatePromotion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: PromotionCreatePayload) => createPromotion(body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['crm', 'promotions'] });
    },
  });
}

export function useArchivePromotion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (promotionId: string) => archivePromotion(promotionId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['crm', 'promotions'] });
    },
  });
}
